import React from "react";
import { useSelector } from "react-redux";

// Components
import { Modal } from "@octopus-investments/deep-sea-components";

// Styles
import "./AccountLocked.scss";

export default function AccountLocked() {
  const { isPermanentlyLocked, isTemporaryLocked } = useSelector(({ application }) => application);

  return (
    !isPermanentlyLocked &&
    isTemporaryLocked && (
      <Modal
        className="account-locked-modal"
        id="AccountLockedModal"
        showCloseIcon={false}
        showModal={isTemporaryLocked}
      >
        <h3 className="coheadline navyBlue">Your account has been locked for 5 minutes.</h3>
        <div className="information-block">
          <p>Due to 3 failed login attempts we have temporarily locked your account.</p>
          <p>
            Please close this page and try again in <strong>5 minutes</strong>.
          </p>
        </div>
      </Modal>
    )
  );
}
